module.exports = __webpack_public_path__ + "assets/naozhong.b68924b4.svg";